import React, { useEffect } from 'react';
import '../../styles/homeSectionA.css';
import { useLanguage } from '../../../contexts/LanguageContext';
import { useNavigate } from 'react-router-dom';
import { highlightIndonesiaLestari } from '../../../utils/textHelper';
import LogoKomunitas from '../../../assets/logo-komunitas.png';
import LogoRiset from '../../../assets/logo-riset.png';
import LogoEdukasi from '../../../assets/logo-edukasi.png';
import GambarKomunitas from '../../../assets/gambar-logo-komunitas.JPEG';
import riset from '../../../assets/riset.png';
import edukasip from '../../../assets/edukasip.png';

const HomeSectionA = () => {
  const { language } = useLanguage();
  const navigate = useNavigate();

  useEffect(() => {
    const revealElements = document.querySelectorAll('.reveal');

    const revealOnScroll = () => {
      revealElements.forEach(el => {
        const windowHeight = window.innerHeight;
        const elementTop = el.getBoundingClientRect().top;
        const elementVisible = 150;

        if (elementTop < windowHeight - elementVisible) {
          el.classList.add('active');
        }
      });
    };

    window.addEventListener('scroll', revealOnScroll);
    revealOnScroll();

    return () => window.removeEventListener('scroll', revealOnScroll);
  }, []);

  const content = {
    en: {
      heading: 'FORPASI: Indonesian National Waste Awareness Forum',
      paragraphs: [
        <>
        FORPASI is a non-partisan platform for discussion and voicing opinions from all parties in Indonesia to stakeholders, aiming to raise awareness about waste issues and create a better waste management system. 
        <br /><br />
        We are the first public forum in Indonesia to present ideas from 3 presidential candidates in the 2024 elections, particularly regarding their vision, mission, and programs related to waste management issues.
        <br /><br />
        Through collaboration and active participation, FORPASI promotes initiatives and public policies for sustainable waste solutions.
        Let's move towards <b>INDONESIA LESTARI</b>
      </>
      ],
      subheading: 'DRIVING WASTE SYSTEM CHANGE THROUGH VOLUNTEER ACTIVITIES',
      ourWork: 'Our Work',
      features: [
        { logo: LogoKomunitas, icon: '🌐', title: 'Digital Community & National Waste Network', image: GambarKomunitas },
        { logo: LogoRiset, icon: '📊', title: 'Research & Policy Advocacy', image: 'https://thumbs.dreamstime.com/b/environment-earth-day-hands-nature-helping-people-nature-s-concept-environment-earth-day-hands-nature-helping-159361634.jpg' },
        { logo: LogoEdukasi, icon: '🎓', title: 'Education, Campaigns & Strategic Programs', image: 'https://thumbs.dreamstime.com/b/environment-earth-day-hands-nature-helping-people-nature-s-concept-environment-earth-day-hands-nature-helping-159361634.jpg' }
      ],
      button: 'Join Us Now'
    },

    id: {
      heading: 'FORPASI: Forum Peduli Sampah Seluruh Indonesia',
      paragraphs: [
        <>
        FORPASI adalah wadah non-partisan untuk berdiskusi dan menyuarakan pendapat dari seluruh pihak di Indonesia kepada para pemangku kepentingan, guna meningkatkan kepedulian terhadap isu sampah dan menciptakan sistem pengelolaan sampah yang lebih baik. 
        <br /><br />
        Kami hadir sebagai forum publik pertama di Indonesia yang menghadirkan gagasan dari 3 calon presiden pada Pemilu 2024, terutama dalam visi-misi-program terkait isu persampahan.
        <br /><br />
        Melalui kolaborasi dan partisipasi aktif, FORPASI mendorong inisiatif dan kebijakan publik untuk solusi persampahan yang berkelanjutan.
        Mari kita bergerak menuju <b>INDONESIA LESTARI</b>
      </>
      ],
      subheading: 'MENDORONG PERUBAHAN SISTEM PERSAMPAHAN MELALUI AKTIVITAS KERELAWANAN',
      ourWork: 'Fokus Kegiatan',
      features: [
        { logo: LogoKomunitas, icon: '🌐', title: 'Komunitas Digital & Jaringan Persampahan Nasional', image: GambarKomunitas },
        { logo: LogoRiset, icon: '📊', title: 'Riset & Advokasi Kebijakan', image: riset },
        { logo: LogoEdukasi, icon: '🎓', title: 'Edukasi, Kampanye & Program Strategis', image: edukasip }
      ],
      button: 'Bergabung Sekarang'
    }
  };




  const currentContent = content[language];

  return (
    <section className="home-section reveal">
      <div className="glass-card">
        {/* Heading */}
        <h1>{currentContent.heading}</h1>

        {/* Paragraphs */}
        {currentContent.paragraphs.map((para, idx) => (
          <p key={idx} style={{ whiteSpace: 'pre-wrap'}}>{(para)}</p>
        ))}

        {/* Subheading */}
        <h2 className="subheading">{highlightIndonesiaLestari(currentContent.subheading)}</h2>

        {/* Our Work Section */}
        <h2 className="our-work">{highlightIndonesiaLestari(currentContent.ourWork)}</h2>
        <div className="features">
          {currentContent.features.map((feature, idx) => (
            <div className="feature-card" key={idx}>
              {feature.logo ? (
                <img src={feature.logo} alt={`${feature.title} logo`} className="feature-logo" />
              ) : (
                <span className="feature-icon">{feature.icon}</span>
              )}
              <h3>{highlightIndonesiaLestari(feature.title)}</h3>
              <div className="feature-image-wrap">
                <img src={feature.image} alt={feature.title} className="feature-image" />
              </div>
            </div>
          ))}
        </div>

        {/* CTA Button */}
        <button 
          className="cta-button"
          onClick={() => navigate('/support-us')}
        >
          {highlightIndonesiaLestari(currentContent.button)}
        </button>
      </div>
    </section>
  );
};

export default HomeSectionA;
